import React, { ReactNode } from 'react';
import { styled } from 'styled-components';

import Row from 'components/common/Row';
import Text from 'components/common/Text';

const Container = styled.div<{
  $isSelected?: boolean;
  $isScrollable?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* gap: 20px; */

  position: relative;

  padding: ${props => (props.$isScrollable ? '0px 0px 24px' : '0px 20px 24px')};

  width: 100%;
  border-radius: 16px;
  border: ${props =>
    props.$isSelected ? '1.5px solid #1b1c1e' : '1px solid  #eaebec'};
  background: #fff;
  /* box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1); */
`;

interface ModifyContainerIProps {
  title: string;
  children: ReactNode;
  isSelected?: boolean;
  modifyDisabled?: boolean;
  modifyText?: string;
  style?: React.CSSProperties;
  isScrollable?: boolean;
  onClick: () => void;
}

const ModifyContainer: React.FC<ModifyContainerIProps> = props => {
  const {
    title,
    children,
    isSelected,
    modifyDisabled,
    modifyText,
    style,
    isScrollable,
    onClick,
  } = props;

  return (
    <Container
      $isSelected={isSelected}
      $isScrollable={isScrollable}
      style={{ ...style }}
    >
      <Row
        justifyContent="space-between"
        style={
          isScrollable
            ? {
                padding: '24px 20px',
                position: 'sticky',
                top: 0,
                left: 0,
                width: '100%',
                background: '#fff',
                zIndex: 2,
              }
            : {
                padding: '24px 0',
                width: '100%',
              }
        }
      >
        <Text color="#1b1c1e" size="18px" weight={600}>
          {title}
        </Text>
        {!modifyDisabled && (
          <Text
            color={'#414B56'}
            weight={600}
            style={{
              padding: '8px 12px',
              backgroundColor: '#f7f7f8',
              borderRadius: '12px',
              cursor: 'pointer',
            }}
            onClick={onClick}
          >
            {modifyText ? modifyText : '수정하기'}
          </Text>
        )}
      </Row>
      {children}
    </Container>
  );
};

export default ModifyContainer;
